import { render } from "./TagModal.vue?vue&type=template&id=c20d79fe"
import script from "./TagModal.vue?vue&type=script&lang=ts"
export * from "./TagModal.vue?vue&type=script&lang=ts"
script.render = render

export default script